export enum FeaturedWorkKey {
  werewolf_online = "werewolf_online",
  avatar_customizing = "avatar_customizing",
  minigames = "minigames",
  pocket_ball = "pocket_ball",
  holdem = "holdem",
  sharp_shooter = "sharp_shooter",
  cms = "cms",
  face = "face",
  soundable = "soundable",
  others = "others",
}

export type ImageType = {
  url: string;
  orientation: "horizontal" | "vertical";
};

export type FeaturedWorkImages = {
  thumbnail: ImageType;
  images: ImageType[];
};

export enum FeaturedWorkImagesLayoutType {
  default,
  include_thumbnail,
  mix, // horizontal and vertical
  include_thumbnail_mix,
}

export type AboutGridItem = {
  // thumbnail: string;
  // imgs: string[];
  imageKey: FeaturedWorkKey;
  videos: string[]; // youtube
  title: string;
  types: AboutGridItemType[];
  subtitle: string;
  description: string;
  layoutType: FeaturedWorkImagesLayoutType;
};

export enum AboutGridItemType {
  Game = "Game",
  Module = "Module",
  App = "App",
  Web = "Web",
  Company = "Company",
  Outsourcing = "Outsourcing",
  Unity = "Unity",
  iOS = "iOS",
  Android = "Android",
  CSharpServer = "CSharpServer",
  SpringBoot = "SpringBoot",
}

export enum ProductType {
  RECREATION = "recreation",
  TOOL = "tool",
}

export type Product = {
  id: number;
  title: string;
  thumbnailUrl: string;
  shortDescription: string;
  type: ProductType;
  attributes: {
    // 공통 속성
    minUsers: number;
    maxUsers: number;
    // Recreation 전용 속성
    gameModes?: GameModeEnum[];
    isCooperative?: boolean;
    // 기능 플래그
    features?: {
      privateChat?: boolean; // 비공개 채팅 기능 활성화 (기본값: false)
    };
  };
};

// export type Recreation = {
//   id: number;
//   title: string;
//   thumbnailUrl: string;
//   shortDescription: string;
//   attributes: RecreationAttributes;
// };

export interface RecreationAttributes {
  gameModes: GameModeEnum[];
  isCooperative: boolean;
  minPlayers: number;
  maxPlayers: number;
}

export enum GameModeEnum {
  team = "team",
  individual = "individual",
}

export interface GeneralRoomParams {
  product: Product;
  room: Room;
}

export type Room = {
  id: number;
  recreationId: number;
  roomName: string;
  roomPassword: string;
  private: boolean;
  userCount: number;
  state: RoomState; // 0: Waiting, 1: InGame
};

// must sync with server
export enum RoomState {
  WAITING = "waiting",
  INGAME = "ingame",
  PAUSE = "pause",
}

// user session
export type User = {
  socketId: string;
  defaultNickName: string;
  nickName: string;
  id: number;
  isHost: boolean;
  state: PlayerState;
  isAI: boolean;
};

export enum MenuButtonType {
  RULE,
  USER_LIST,
  GAME_SETTING,
  MENU,
}

export interface Message {
  user: string;
  userId: number;
  content: string;
  type: "join" | "leave" | "message" | "self";
  smallChatKey: string;
  // 서버에서 할당 (재접속 시 동기화용)
  index?: number; // 서버의 순차 인덱스
  timestamp?: number; // Unix timestamp (ms)
}
export enum J2HGameState {
  WAITING,
  START,
  END,
}
export enum PlayerState {
  WAITING = "waiting",
  INGAME = "ingame",
  DISCONNECTED = "disconnected",
  OBSERVING = "observing",
}
